import { useFormContext } from 'react-hook-form';
import {
  ConnectedAutoFillCustomersButton,
  ConnectedAutoFillMe,
  ConnectedAutoFillVendorsButton,
} from '../../../auto-fill-contacts';
import { InvoiceForm } from '../InvoiceForm';
import { InvoiceFormType } from '../types';
import { ConnectedCustomerForm } from './ConnectedCustomerForm';
import { ConnectedVendorForm } from './ConnectedVendorForm';

type InvoiceFormProps = {
  readonly?: boolean;
  onSubmit: (data: InvoiceFormType) => void;
  highlightAreas?: boolean;
  formId?: string;
  allowInvoiceItems?: boolean;
};

export const ConnectedInvoiceForm = ({
  readonly,
  onSubmit,
  highlightAreas = true,
  formId,
  allowInvoiceItems = true,
}: InvoiceFormProps) => {
  const contextMethods = useFormContext<InvoiceFormType>();

  const selectedCurrency = contextMethods.watch('currency');

  if (!contextMethods) {
    throw new Error(
      'Using `ConnectedInvoiceForm` is allowed only inside react-hook-form context. Place `ConnectedInvoiceForm` as child of `FormProvider`',
    );
  }

  return (
    <InvoiceForm
      formId={formId}
      readonly={readonly}
      highlightAreas={highlightAreas}
      control={contextMethods.control}
      setValue={contextMethods.setValue}
      onSubmit={contextMethods.handleSubmit(onSubmit)}
      selectedCurrency={selectedCurrency}
      slots={{
        customerSlot: <ConnectedCustomerForm readonly={readonly} />,
        vendorSlot: <ConnectedVendorForm readonly={readonly} />,
        invoiceHeaderSlot: <ConnectedAutoFillMe />,
        customerHeaderSlot: readonly ? null : <ConnectedAutoFillCustomersButton />,
        vendorHeaderSlot: readonly ? null : <ConnectedAutoFillVendorsButton />,
      }}
      allowInvoiceItems={allowInvoiceItems}
    />
  );
};
